// Import components.
import Sharing from './components/Sharing.jsx';

/**
 * <pre>
 * Sharing module React Components.
 *
 * Summary of responsibilities:
 *
 *  - defines React components that this app module can render
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Sharing
 * @namespace
 *
 * @type {Object}
 */
const Components = {
	Sharing: Sharing
};

export default Components;